import { OnePagerContext } from './context';
import { OnePagerSectionConfig } from '../editor/dealSummaryEditorInitializer';
import { CREDIT_BUREAU_HEADERS, NAME_DISPLAY_KEY } from '../editor/dealSummaryEditorConstants';
import { h2, spacer, table, td, text, th, tr, TrRow } from './plateNodes';

export function buildCreditBureauSection(ctx: OnePagerContext, section: OnePagerSectionConfig): any[] | null {
    const { combinedDirectors } = ctx;

    if (!combinedDirectors?.length) return null;

    const headerRow: TrRow = tr(CREDIT_BUREAU_HEADERS.map((header) => th([text(header.label, { bold: true })])));

    const dataRows: TrRow[] = combinedDirectors.map((director: any) =>
        tr(
            CREDIT_BUREAU_HEADERS.map((header) =>
                td([
                    text(
                        String(
                            header.key === NAME_DISPLAY_KEY
                                ? director?.nameDisplay ?? director?.name ?? '-'
                                : director?.[header.key] ?? '-',
                        ),
                    ),
                ]),
            ),
        ),
    );

    return [h2([text(section.label)]), table([headerRow, ...dataRows]), spacer()];
}
